import React from 'react'

export default function StarHalfIcon({ size = 14, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_17356_47174)">
        <path d="M13.2714 4.87735L9.08036 4.23716L7.20182 0.235814C7.06151 -0.0629798 6.57129 -0.0629798 6.43098 0.235814L4.553 4.23716L0.361933 4.87735C0.0176943 4.93018 -0.119774 5.34883 0.121647 5.59593L3.16639 8.7168L2.44668 13.1288C2.3893 13.4793 2.76365 13.7423 3.07323 13.5702L6.81668 11.5014L10.5601 13.5708C10.8669 13.7412 11.2446 13.4833 11.1867 13.1294L10.467 8.71737L13.5117 5.5965C13.7531 5.34883 13.6151 4.93018 13.2714 4.87735Z" fill="#FFC107" />
        <mask id="mask0_17356_47174" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
          <path d="M13.2714 4.87735L9.08036 4.23716L7.20182 0.235814C7.06151 -0.0629798 6.57129 -0.0629798 6.43098 0.235814L4.553 4.23716L0.361933 4.87735C0.0176943 4.93018 -0.119774 5.34883 0.121647 5.59593L3.16639 8.7168L2.44668 13.1288C2.3893 13.4793 2.76365 13.7423 3.07323 13.5702L6.81668 11.5014L10.5601 13.5708C10.8669 13.7412 11.2446 13.4833 11.1867 13.1294L10.467 8.71737L13.5117 5.5965C13.7531 5.34883 13.6151 4.93018 13.2714 4.87735Z" fill="#FFC107" />
        </mask>
        <g mask="url(#mask0_17356_47174)">
          <path d="M8.71094 13.634V1.51562H14.0127V14.3914H8.71094V13.634Z" fill="#CACACA" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_17356_47174">
          <rect width="13.6332" height="13.6332" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
